import { render, staticRenderFns } from "./upload-receipts.vue?vue&type=template&id=345168ce&scoped=true"
import script from "./upload-receipts.vue?vue&type=script&lang=js"
export * from "./upload-receipts.vue?vue&type=script&lang=js"
import style0 from "./upload-receipts.vue?vue&type=style&index=0&id=345168ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345168ce",
  null
  
)

export default component.exports